

import { Modal as AntdModal, Button } from 'antd';
import {
    useEffect,
    useState
} from 'react';

export default function Externals({
    comps,
    setComps,
    setView,
    pages,
    setPages,
    vars,
    setVars,
    externals,
    setExternals
}) {

    // 'Flags' = list view (the menu opens straight here), 'Edit Flag' = editor.
    const [modalTitle, setModalTitle] = useState('Flags');
    const [isEditingFlag, setIsEditingFlag] = useState(-1);

    const [flagName, setFlagName] = useState('');

    useEffect(() => {
        if (isEditingFlag >= 0) {
            setFlagName(externals.flags[isEditingFlag].name);
        }
    }, [isEditingFlag])

    // ---- Flag list ---------------------------------------------------------
    let flags_overview = [];
    if (!externals?.flags || externals.flags.length === 0) {
        flags_overview = <div style={{
            padding: '28px 0',
            textAlign: 'center',
            color: 'var(--ed-text-soft)',
            fontWeight: 400
        }}>
            <i className="fa fa-flag-o" style={{ fontSize: 28, display: 'block', marginBottom: 10, opacity: 0.6 }}></i>
            No flags yet — use “Add Flag” below to create one.
        </div>;
    } else {
        for (let k = 0; k < externals.flags.length; ++k) {
            const flag = externals.flags[k];
            const defaultIdx = parseInt(flag.value);
            flags_overview.push(
                <div key={k} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    padding: '10px 12px',
                    border: '1px solid var(--ed-border)',
                    borderRadius: 8,
                    marginBottom: 8,
                    background: 'var(--ed-surface-2)'
                }}>
                    <div style={{ display: 'flex', gap: 4, flex: '0 0 auto' }}>
                        {flag.colors.map((c, ci) => (
                            <span key={ci} style={{
                                width: 14,
                                height: 14,
                                borderRadius: 3,
                                background: c,
                                border: '1px solid rgba(16,24,40,.15)',
                                boxShadow: ci === defaultIdx ? '0 0 0 2px var(--ed-accent)' : 'none'
                            }}></span>
                        ))}
                    </div>
                    <span style={{
                        flex: '1 1 auto',
                        minWidth: 0,
                        fontWeight: 500,
                        color: 'var(--ed-text)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}>{flag.name}</span>
                    <a className='panel-button' onClick={(e) => {
                        e.preventDefault();
                        setIsEditingFlag(k);
                        setModalTitle('Edit Flag');
                    }}>
                        <i className="fa fa-pencil" style={{ marginRight: 6 }}></i>Edit
                    </a>
                    <a className='panel-button prop-danger' onClick={(e) => {
                        e.preventDefault();
                        let new_externals = { ...externals };
                        new_externals.flags.splice(k, 1);
                        setExternals(new_externals);
                    }}>Delete</a>
                </div>
            );
        }
    }

    // ---- States of the flag being edited -----------------------------------
    let flag_overview = [];
    if (isEditingFlag >= 0) {
        for (let k = 0; k < externals?.flags[isEditingFlag]?.values?.length; ++k) {
            const isDefault = parseInt(externals.flags[isEditingFlag].value) === k;
            flag_overview.push(
                <div key={k} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '8px 10px',
                    borderRadius: 8,
                    marginBottom: 8,
                    border: isDefault ? '1px solid var(--ed-accent)' : '1px solid var(--ed-border)',
                    background: isDefault ? 'var(--ed-accent-soft)' : 'var(--ed-surface-2)'
                }}>
                    <input type='color' className='panel-color-input' style={{
                        width: '2vmax',
                        flex: '0 0 auto'
                    }} onChange={(e) => {
                        let new_externals = { ...externals };
                        new_externals.flags[isEditingFlag].colors[k] = e.target.value;
                        setExternals(new_externals);
                    }} value={externals.flags[isEditingFlag].colors[k]} />
                    <input className='panel-input' value={externals.flags[isEditingFlag].values[k]} style={{
                        flex: '1 1 auto',
                        minWidth: 0,
                        fontWeight: isDefault ? 500 : 400,
                        color: isDefault ? 'var(--ed-accent)' : 'var(--ed-text)'
                    }} onChange={(e) => {
                        let new_externals = { ...externals };
                        new_externals.flags[isEditingFlag].values[k] = e.target.value;
                        setExternals(new_externals);
                    }}></input>
                    <i className={isDefault ? 'fa fa-star pointy' : 'fa fa-star-o pointy'}
                        title={isDefault ? 'Default state' : 'Set as default'}
                        style={{
                            flex: '0 0 auto',
                            fontSize: '1.25vmax',
                            color: isDefault ? '#f1a722' : 'var(--ed-text-soft)'
                        }} onClick={(e) => {
                            e.preventDefault();
                            let new_externals = { ...externals };
                            new_externals.flags[isEditingFlag].value = k;
                            setExternals(new_externals);
                        }}></i>
                    <i className="fa fa-trash pointy" title="Delete state" style={{
                        flex: '0 0 auto',
                        fontSize: '1.15vmax',
                        color: 'var(--ed-text-soft)'
                    }} onClick={(e) => {
                        e.preventDefault();
                        if (externals.flags[isEditingFlag]?.values?.length > 1) {
                            let new_externals = { ...externals };
                            new_externals.flags[isEditingFlag].values.splice(k, 1);
                            new_externals.flags[isEditingFlag].colors.splice(k, 1);
                            new_externals.flags[isEditingFlag].value = 0;
                            setExternals(new_externals);
                        }
                    }}></i>
                </div>
            );
        }
    }

    const flag_manager_footer = [
        <Button key="add" type="primary" onClick={(e) => {
            e.preventDefault();
            let new_externals = {
                ...externals
            };
            if (new_externals["flags"] === undefined || new_externals["flags"] === null) {
                new_externals["flags"] = [];
            }
            new_externals.flags.push({
                name: 'New Flag ' + (new_externals.flags.length + 1),
                values: ['Incomplete', 'In Progress', 'Complete'],
                colors: ['#E74C3C', '#F1C40F', '#2ECC71'],
                value: 0
            });
            setExternals(new_externals);
        }}>
            Add Flag
        </Button>,

        <Button key="close" type="primary" danger onClick={(e) => { setView(''); }}>
            Close
        </Button>
    ];

    const edit_flag_footer = [
        <Button key="add" type="primary" onClick={(e) => {
            e.preventDefault();
            let new_externals = { ...externals };
            new_externals.flags[isEditingFlag].values.push('New State');
            new_externals.flags[isEditingFlag].colors.push('#ffffff');
            setExternals(new_externals);
        }}>
            Add State
        </Button>,

        <Button key="back" type="primary" danger onClick={(e) => {
            setModalTitle('Flags');
            let new_externals = { ...externals };
            if (new_externals.flags[isEditingFlag].name === '') {
                new_externals.flags[isEditingFlag].name = flagName;
                setExternals(new_externals);
            }
        }}>
            Back
        </Button>
    ];

    return <>
        <AntdModal className="cf-modal" title={modalTitle === 'Edit Flag' ? 'Edit Flag' : 'Flags'} visible={true} onOk={() => {
            setView('');
        }} onCancel={() => {
            setView('');
        }}
            footer={modalTitle === 'Edit Flag' ? edit_flag_footer : flag_manager_footer}
        >
            {
                modalTitle !== 'Edit Flag' ? (
                    <div>
                        {flags_overview}
                    </div>
                ) : (
                    <div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            padding: '12px 14px',
                            border: '1px solid var(--ed-border)',
                            borderRadius: 8,
                            background: 'var(--ed-surface-2)',
                            marginBottom: 16
                        }}>
                            <span style={{
                                flex: '0 0 auto',
                                fontWeight: 500,
                                color: 'var(--ed-text-soft)'
                            }}>Flag Name</span>
                            <input className='panel-input' value={externals?.flags[isEditingFlag]?.name} style={{
                                flex: '1 1 auto',
                                minWidth: 0,
                                fontWeight: 500,
                                color: 'var(--ed-text)'
                            }} onChange={(e) => {
                                let new_externals = { ...externals };
                                new_externals.flags[isEditingFlag].name = e.target.value;
                                setExternals(new_externals);
                            }} />
                        </div>

                        <p style={{
                            fontSize: 11,
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            letterSpacing: '.04em',
                            color: '#9aa4af',
                            margin: '0 0 8px'
                        }}>States</p>
                        {flag_overview}
                    </div>
                )
            }
        </AntdModal>
    </>;

}
